import { createContext, PropsWithChildren, useContext } from "react";

type SidebarOpen = boolean;
const SidebarOpenContext = createContext<SidebarOpen | undefined>(undefined);

export const useSidebarOpen = () => {
  const api = useContext(SidebarOpenContext);
  if (api === undefined) {
    throw new Error("useSidebarOpen must be used within an SidebarOpenProvider");
  }
  return api;
};

type SidebarOpenProviderProps = PropsWithChildren<{ open: boolean }>;
export const SidebarOpenProvider = ({ open, children }: SidebarOpenProviderProps) => {
  return <SidebarOpenContext.Provider value={open}>{children}</SidebarOpenContext.Provider>;
};
